<svg
  width="21"
  height="21"
  viewBox="0 0 21 21"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.5 20C15.7467 20 20 15.7467 20 10.5C20 5.25329 15.7467 1 10.5 1C5.25329 1 1 5.25329 1 10.5C1 15.7467 5.25329 20 10.5 20ZM9.71722 6.40591V7.68989H11.0125V6.40591H9.71722ZM8.17419 13.7719V14.5941H12.8258V13.7719H11.0012V8.72608H8.28682V9.54828H10.0776V13.7719H8.17419Z"
    fill="black"
  />
</svg>
